import {
  AttachFileOutlined,
  AttachmentOutlined,
  UploadFileOutlined,
} from "@mui/icons-material";
import { useMemo, useState } from "react";
import QuickActionButton from "../shared/QuickActionButton";

import { isEmpty, size } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import SelectAutoInput from "../../../components/inputs/SelectAutoInput";
import InputWrapper from "../../../components/inputs/shared/InputWrapper";
import FileUploadModal from "../../../components/modals/common/FileUploadModal";
import { useEndpointHook } from "../../../hooks/useEndpointHook";
import { financingRequestsClear } from "../../../redux/reducers/financingRequestsReducer";

const QuickActionUploadLoanDocuments = ({ disabled }) => {
  const financingRequests = useSelector((state) => state?.financingRequests);
  const dispatch = useDispatch();
  const { uploadFilesToLoan, loading } = useEndpointHook();
  const [showModal, setShowModal] = useState(false);
  const [loanId, setLoanId] = useState(null);

  const loanOptions = useMemo(() => {
    return financingRequests?.map((fr) => {
      return { label: fr?.loanName, value: fr?._id };
    });
  }, [financingRequests]);

  const handleOnLoanSelect = (id) => {
    setLoanId(id);
  };

  const handleOnClose = () => {
    setLoanId(null);
    setShowModal(false);
  };

  const handleOnClick = () => {
    if (size(financingRequests) === 1) {
      const loanData = financingRequests[0];
      handleOnLoanSelect(loanData?._id);
    }
    setShowModal(true);
  };

  const handleOnSubmit = (files) => {
    console.log("files", { files, loanId });

    uploadFilesToLoan({
      dealId: loanId,
      files,
      onSuccessFn: () => {
        handleOnClose();
        dispatch(financingRequestsClear());
      },
    });
  };

  if (isEmpty(financingRequests)) {
    return null;
  }

  return (
    <>
      {showModal && (
        <FileUploadModal
          show={showModal}
          title={`Upload Supporting Loan Documents`}
          // files={files}

          description={`Upload documents for your financing request.`}
          // docGroup={docGroup}
          // docType={docType}
          onSubmit={handleOnSubmit}
          key={`loan-quick-upload-modal-upload`}
          onClose={handleOnClose}
          startContent={
            <LoanSelector
              value={loanId}
              onChange={handleOnLoanSelect}
              options={loanOptions}
            />
          }
          loading={loading}
          // onSubmit={onSubmit}
        />
        // <UploadLoanFileModal
        //   title={`Upload Documents`}
        //   show={loanId}
        //   onClose={handleOnClose}
        // />
      )}
      <QuickActionButton
        disabled={disabled}
        title="Upload Supporting Loan Documents"
        onClick={handleOnClick}
        description="Add documents to an existing financing request."
        icon={<AttachFileOutlined className="thin" />}
      />
    </>
  );
};

const LoanSelector = ({ options, onChange, value }) => {
  return (
    <InputWrapper label="Select a loan" mb={2}>
      <SelectAutoInput options={options} onChange={onChange} value={value} />
    </InputWrapper>
  );
};

export default QuickActionUploadLoanDocuments;
